// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"Pagination_paginationContainer__9HcHY","button":"Pagination_button__mbV9E","active":"Pagination_active__9_4xV"};